import React from "react"
import { CustomIconButton } from "shared/buttons"
import { useSelector } from "react-redux"
import { subscribedToAddOnFeature } from "reduxSlices/addOnFeatureSubscriptionsSlice"
import { AUTHENTICATED_FORMS_FEATURE_NAME } from "utils/addOnFeatureHelpers"
import CreateUserModal from "shared/modals/CreateUserModal"
import ImportUsersModal from "shared/modals/ImportUsersModal"
import { ACTIVITY_HUB_AH_USER_IMPORTS_PATH, redirectTo } from "utils/routeHelpers"

const CreateUserButtons = () => {
  const subscribedToAuthenticatedForms = useSelector(subscribedToAddOnFeature(AUTHENTICATED_FORMS_FEATURE_NAME))

  return (
    <div className="flex justify-center items-center">
      <CreateUserModal />
      <span className="mx-4 text-dark font-medium text-sm">or</span>
      {
        subscribedToAuthenticatedForms
          ? <ImportUsersModal />
          : (
            <CustomIconButton
              text="Import From CSV"
              className="tertiary-button"
              icon="import-csv"
              onClick={() => redirectTo(ACTIVITY_HUB_AH_USER_IMPORTS_PATH)}
            />
          )
      }
    </div>
  )
}
export default CreateUserButtons
